import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useEffect, useRef } from "react";
import { useWindowSize } from "react-use";
gsap.registerPlugin(ScrollTrigger);

const ReversedSection = ({ imgSrc, leftMediaText, rightMediaText }) => {
  const { width } = useWindowSize();
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const boxRef = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add("(min-width: 992px)", () => {
        gsap.fromTo(
          leftRef?.current,
          {
            xPercent: "-65",
          },
          {
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: leftRef?.current,
              // markers: true,
              start: "top 60%",
              end: "top 25%",
              scrub: 2,
            },
          }
        );

        gsap.fromTo(
          rightRef?.current,
          {
            opacity: 0,
            xPercent: "50",
          },
          {
            delay: 0.5,
            opacity: 1,
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: rightRef?.current,
              // markers: true,
              start: "top 55%",
              end: "top 25%",
              scrub: 2,
            },
          }
        );
      });

      mm.add("(min-width: 768px) and (max-width: 991px)", () => {
        gsap.fromTo(
          leftRef?.current,
          {
            xPercent: "-65",
          },
          {
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: leftRef?.current,
              // markers: true,
              start: "top 45%",
              end: "top 40%",
              scrub: 2,
            },
          }
        );

        gsap.fromTo(
          rightRef?.current,
          {
            opacity: 0,
            xPercent: "50",
          },
          {
            delay: 0.5,
            opacity: 1,
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: rightRef?.current,
              // markers: true,
              start: "top 40%",
              end: "top 40%",
              scrub: 2,
            },
          }
        );
      });

      return () => mm.revert();
    },
    [],
    { scope: boxRef.current }
  );
  return (
    <div
      // className="w-full md:pl-[10rem] 2xl:pl-[19.56rem]  py-10 relative"
      className="w-full lg:pr-[11.67vw] lg:pl-[16.30vw] 2xl:pl-[13rem] relative"
      data-aos={width > 768 ? "" : "fade-up"}
    >
      <div className="w-full flex flex-col md:flex-row-reverse justify-center px-[4vh]">
        {/* Right side (previously the left side in Mediasection) */}

        <div
          ref={leftRef}
          className="z-10 md:w-[32.08vw] w-[91.47vw] w-full flex flex-col items-center justify-center bg-glass/30 backdrop-blur-3xl  md:py-4 py-8 px-[5vw]"
        >
          <div className="">
            <div className="flex items-center justify-center">
              <img
                src={imgSrc}
                alt=""
                className="md:w-[5.36vw]  w-[21.33vw]  object-contain p-2"
              />
            </div>
            <p className="lg:w-full h-auto  text-center text-transparent bg-clip-text bg-text-gradient font-bebas_neue md:text-[2.08vw] text-[8.53vw] tracking-normal ">
              {leftMediaText}
            </p>
          </div>
        </div>

        {/* Left side (previously the right side in Mediasection) */}
        <div
          ref={rightRef}
          className="px-[24px] md:px-12 py-[32px] w-[91.47vw] w-full h-auto sm:min-h-[152px] md:w-[39.96vw] md:h-[14.46vw] flex flex-col  justify-center md:py-4 border-[1px] border-gray-100 border-solid border-opacity-30"
        >
          <p className="text-left font-light md:text-[1.15vw] text-[5.33vw]  tracking-normal font-montserrat text-gray-100   overflow-hidden">
            {rightMediaText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReversedSection;
